import { pick, includes } from 'lodash';
import * as React from 'react';
import styled from 'styled-components';

import API from '../../lib/BackendAPI';
import Colors from '../../lib/Colors';
import { getCurrentQueryParams } from '../../lib/queryParams';
import { fullProfileSchema, IProfile } from '../../lib/types/Profile';
import ButtonFooter from '../ButtonFooter';
import CardWithHeader from '../CardWithHeader';
import AddressForm from './AddressForm';
import padStart from './padStart';
import { parseISODate } from './parseISODate';

interface IProps {
  className?: string;
  onGoBack: () => void;
  onShowConfirmationScreen: () => void;
}

interface IState {
  profile: IProfile & { year?: string, month?: string, day?: string };
  isSubmitted: boolean;
  isLoaded: boolean;
  year?: string | undefined;
  month?: string | undefined;
  day?: string | undefined;
}

class UnstyledAddressEditor extends React.Component<IProps> {
  public state: IState = {
    isSubmitted: false,
    profile: {},
    isLoaded: false,
  };

  public componentDidMount() {
    this.fetchOrSaveData();
  }

  public renderFooter(isValid: boolean) {
    return <ButtonFooter>
      <button
      onClick={this.updateData}
      disabled={!this.state.isLoaded || this.state.isSubmitted || !isValid}>
        Bestätigen
      </button>
    </ButtonFooter>;
  }

  public render() {
    const context = fullProfileSchema.newContext();
    context.validate(context.clean(this.state.profile));
    const isValid = context.isValid();

    const header = <React.Fragment>
      <span className="title">Deine Adresse</span>
    </React.Fragment>;

    return (
      <CardWithHeader
        title={header}
        className={this.props.className}
        onGoBack={this.props.onGoBack}
        footer={this.renderFooter(isValid)}
      >
        {this.state.isSubmitted && <section className="confirm-saved">
          <header className="check-icon">✓</header>
          <footer>Deine Adresse wurde gespeichert.</footer>
        </section>}

        {!this.state.isSubmitted && this.state.isLoaded && <section>
          <AddressForm
            profile={this.state.profile}
            onChange={this.onChange}
          />
        </section>}
      </CardWithHeader>
    );
  }

  private updateData = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const fieldNames = [
      'nickname',
      'firstName',
      'lastName',
      'gender',
      'birthdayISO',
      'street',
      'city',
      'postalCode',
    ];
    await this.fetchOrSaveData(pick(this.state.profile, fieldNames));
    this.setState({ isSubmitted: true });
    setTimeout(() => { this.props.onShowConfirmationScreen(); }, 2000);
  }

  private onChange = (e: React.FormEvent<HTMLInputElement>) => {
    if (!e.target) {
      return;
    }
    const { name, value } = e.currentTarget;
    this.setState({ isSubmitted: false });
    const profile = {
      ...this.state.profile,
      [name]: value,
    };

    const { year, month, day } = profile;
    if (year && month && day) {
      if (includes(['year', 'month', 'day'], name)) {
        const pad = padStart;
        profile.birthdayISO = `${pad(year, 4, '0')}-${pad(month, 2, '0')}-${pad(day, 2, '0')}`;
        Object.assign(profile, parseISODate(profile.birthdayISO));
      }
    }

    console.log(e.currentTarget.name, e.currentTarget.value, profile);
    this.setState({ profile });
  }

  private async fetchOrSaveData(data?: any) {
    const idToken = getCurrentQueryParams().idToken;
    const response = await API.fetchDetails(idToken, data);
    const { year, month, day } = parseISODate(response.birthdayISO);
    this.setState({ isLoaded: true, profile: Object.assign({}, response, { year, month, day }) });
  }
}

const AddressEditor = styled(UnstyledAddressEditor)`
  @keyframes zoomOut {
    0% {
      transform: scale3d(5, 5, 1);
      opacity: 0;
    }
    100% {
      transform: scale3d(1, 1, 1);
      opacity: 1;
    }
  }

  section.confirm-saved {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .check-icon {
      color: ${Colors.primary};
      font-size: 2rem;
      animation: zoomOut 0.2s ease-out forwards;
    }
  }

`;

export default AddressEditor;



// WEBPACK FOOTER //
// ./src/components/AddressEditor/AddressEditor.tsx